import API from '../utils/api';
import { SETTLEMENT_ENABLE_DISABLE } from '../constants';

export const enablesettlemets = (sellerId, cbFn) => {
    return API.post(`/${SETTLEMENT_ENABLE_DISABLE}/${sellerId}/enable/settlements`).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        //cbFn('Unexpected Error', true)
    })
}

export const disablesettlemets = (sellerId, cbFn) => {
    return API.post(`/${SETTLEMENT_ENABLE_DISABLE}/${sellerId}/disable/settlements`).then((response) => {
        if (response.data && response.data.status && response.data.status === "success") {
            cbFn(response.data.desc);
        } else if (response.data && response.data.status === "error") {
            cbFn(response.data.desc, true);
        }
    }).catch((error) => {
        //cbFn('Unexpected Error', true)
    })
}

export const getSettlements = async (queryParams = { limit: 10, skip: 0 }) => {
    let query = `limit=${queryParams.limit}&skip=${queryParams.skip}`

    if (queryParams.seller_id) {
        query += `&seller_id=${queryParams.seller_id}`
    }

    if (queryParams.toDate) {
        query += `&toDate=${queryParams.toDate}`
    }

    if (queryParams.fromDate) {
        query += `&fromDate=${queryParams.fromDate}`
    }

    if (queryParams.business_name) {
        query += `&business_name=${queryParams.business_name}`
    }

    return API.get(`/admin/settlement/pending/sellers?${query}`);
}

export const getSettlementHistory = async (data) => {
    return API.post(`/admin/settlement/history`, data);
}

export const getSellerOrders = async (sellerId, isSettlement, settilementId, fromDate, toDate) => {
    let queryParams = `seller_id=${sellerId}`
    if (isSettlement) {
        queryParams += `&settlement=${isSettlement}&settlement_id=${settilementId}`
    }

    if (toDate) {
        queryParams += `&toDate=${toDate}`
    }

    if (fromDate) {
        queryParams += `&fromDate=${fromDate}`
    }


    return API.get(`/admin/settlement/orders?${queryParams}`);
}

export const updateSettledOrders = async (sellerId, settlementData) => {
    return API.post(`/admin/settlement/settle-amount/${sellerId}`, settlementData);
}

export const updateSettlemetNoteAndAmount = async (settlementData) => {
    return API.post(`/admin/settlement/order/add-note`, settlementData);
}
